import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import { useUpdateUserRolesMutation, type RoleNameEnum, type UsersQuery } from '@/gql/myomr'
import { showNotification } from '@/helpers/notificationHelper'

export function useUserRoleEdit() {
  const router = useRouter()
  const { t } = useI18n()
  const { mutate: updateUserRolesMutation, loading } = useUpdateUserRolesMutation()

  function editUser(user: UsersQuery['users']['nodes'][number], roleNames: RoleNameEnum[], onSuccess?: () => void) {
    if (!user?.id) return

    updateUserRolesMutation({
      roleNames: roleNames,
      userId: user.id,
    })
      .then((result) => {
        const errors = result?.data?.updateUserRoles?.errors || []
        if (errors.length) {
          showNotification(errors.join(), 'error')
        } else {
          const message = roleNames.length
            ? t('UserManagement.Notifications.successfulEdit', {
                email: user.email,
              })
            : t('UserManagement.Notifications.successfulDeletion', {
                email: user.email,
              })
          showNotification(message, 'success')
          onSuccess?.()
          router.push({ name: 'userList' })
        }
      })
      .catch((error) => {
        const message = error?.message || t('UserManagement.Notifications.generalError')
        showNotification({
          type: 'error',
          message,
        })
      })
  }

  return {
    editUser,
    loading,
  }
}
